import axios from 'axios';
import generateVersionHash from '@utils/generateVersionHash';
import { postApi } from '../../lib/fetcher';
import { showAlert } from '@/lib/helpers';

const nfcTransaction = {
  namespaced: true,

  state() {
    return {
      allData: [],
      totalData: 0,
      loading: false,
      cacheData: {},
      errors: [],
      item: null,
      insertProgress: 0,
      downloadFailedURL: '',
      countDone: 0,
      countSame: 0,
      intervalExport: null,
      exportId: null,
      countDataExport: 0,
      totalPage: 0,
      requestData: null,
    };
  },

  mutations: {
    setData(state, { payload }) {
      state.allData = payload.data.list;
    },

    setItem(state, { payload }) {
      state.item = payload.data;
    },

    setCategory(state, data) {
      state.allCategory = data;
    },
    clearData(state) {
      state.allData = [];
      state.totalData = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalData(state, { payload }) {
      state.totalData = parseInt(payload.data.count_data, 10);
      state.totalPage = parseInt(payload.data.total_page, 10);
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setInsertProgress(state, insertProgress) {
      state.insertProgress = insertProgress;
    },

    setIntervalExport(state, payload) {
      state.intervalExport = payload;
    },

    setExportData(state, payload) {
      state.exportId = payload.export_id;
      state.countDataExport = payload.count_data;
    },

    setStateVariable(state, { payload, variable }) {
      state[variable] = payload;
    },

    setCancelation(state, payload) {
      state.requestData = payload;
    },
  },

  actions: {
    async getData(ctx, { date, page, itemsPerPage, search }) {
      const URL_API = '/index.php?r=api/v1/report/report-nfc/index';

      try {
        if (ctx.state.requestData) ctx.state.requestData.cancel();

        const axiosSource = axios.CancelToken.source();

        ctx.commit('setCancelation', {
          cancel: axiosSource.cancel,
          msg: 'Loading...',
        });

        ctx.commit('clearData');
        ctx.commit('setLoading', true);
     
        const version = generateVersionHash(page.toString() + itemsPerPage.toString(), date);
        const data = JSON.stringify({
          page: page.toString(),
          limit: itemsPerPage.toString(),
          search,
          sort_by: 'trx_datetime DESC',
          version
        });

        const addConfig = { cancelToken: axiosSource.token };

        const responseData = await postApi(ctx, URL_API, data, addConfig);

        if (responseData?.code === 200) {
          ctx.commit('setTotalData', { payload: responseData });
          ctx.commit('setData', { payload: responseData });
        } 
      } catch (error) {
        showAlert(
          ctx,
          'Failed to fetch data',
          'mdi-alert',
          'red'
        );
      } finally {
        ctx.commit('setLoading', false);
      }
    },

    async getDetail(ctx, { itemId, date }) {
      const URL_API = '/index.php?r=api/v1/report/report-nfc/view';

      try {
        ctx.commit('setLoading', true);
     
        const version = generateVersionHash(itemId.toString(), date);
        const data = JSON.stringify({
          id: itemId,
          version
        });

        const responseData = await postApi(ctx, URL_API, data);

        if (responseData?.code === 200) {
          ctx.commit('setItem', { payload: responseData });
        } 
      } catch (error) {
        showAlert(
          ctx,
          'Failed to fetch data CCCCC',
          'mdi-alert',
          'red'
        );
      } finally {
        ctx.commit('setLoading', false);
      }
    },
  },
};
export default nfcTransaction;
